import { ShippingTypeAction } from '../../../models/shipping-type-action.type';
import { RecipientTypeOption } from '../models/recipient-type-options.interface';

/**
 * Formatea las opciones de tipo de destinatario basado en la acción de envío.
 * @param shippingType - Tipo de envío.
 * @returns
 */
export const formatRecipientTypes = (
  shippingType: ShippingTypeAction
): RecipientTypeOption[] => {
  return [
    {
      title: `Yo voy a ${shippingType} el pedido`,
      value: 'SELF',
    },
    {
      title: `Otra persona también puede ${shippingType} el pedido`,
      value: 'ANOTHER',
    },
  ];
};
